<main class="main" id="top">
  <div class="container" data-layout="container">
    <div class="row flex-center min-vh-80 py-2">
      <div class="col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">

        <a class="d-flex flex-center mb-4" href="#">
          <img class="mr-2" src="../../assets/img/illustrations/VMI_LOGO.png" alt="" width="250" />
        </a>

        <div class="card login-card-bg login-card-size slb-header">
          <div class="card-body p-4 p-sm-5">

            <div class="row text-left justify-content-between align-items-center mb-2">
              <div class="col-auto">
                <h5 style="color:#fff;font-size:1.1rem">
                  Log in VMI Store - SLB Workplace for Orders
                </h5>
              </div>
            </div>

            <!-- LOGIN FORM -->
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" *ngIf="loginStep === 'email' || loginStep === 'password'">

              <div class="form-group">
                <input class="form-control"
                       type="email"
                       placeholder="Email"
                       formControlName="email"
                       tabindex="1"
                       [readonly]="loginStep !== 'email'"
                       [ngClass]="{ 'is-invalid': submitted && loginFormControl.email.errors }"
                       autocomplete="username" />

                <div *ngIf="submitted && loginFormControl.email.errors" class="invalid-feedback">
                  <div *ngIf="loginFormControl.email.errors.required">Email is required</div>
                  <div *ngIf="loginFormControl.email.errors.email">Email is not valid</div>
                </div>
              </div>

              <div class="form-group" *ngIf="loginStep === 'password'">
                <input class="form-control"
                       type="password"
                       placeholder="Password"
                       formControlName="password"
                       tabindex="2"
                       [ngClass]="{ 'is-invalid': submitted && loginFormControl.password.errors }"
                       autocomplete="current-password" />

                <div *ngIf="submitted && loginFormControl.password.errors" class="invalid-feedback">
                  <div *ngIf="loginFormControl.password.errors.required">Password is required</div>
                </div>
              </div>

              <div class="form-group" *ngIf="loginStep === 'password' && showCaptcha">
                <div class="d-flex justify-content-center">
                  <div class="g-recaptcha"
                       [attr.data-sitekey]="siteKey"
                       data-callback="onCaptchaSuccess"
                       data-expired-callback="onCaptchaExpired"
                       data-error-callback="onCaptchaExpired">
                  </div>
                </div>

                <div *ngIf="submitted && loginFormControl.recaptchaToken?.errors"
                     class="text-danger small mt-2 text-center">
                  Please verify that you are not a robot
                </div>
              </div>

              <div class="form-group" *ngIf="loginStep === 'email'">
                <button type="button"
                        class="btn btn-primary btn-block mt-3"
                        [disabled]="loading"
                        (click)="checkEmail()">
                  {{ loading ? 'Checking...' : 'Next' }}
                </button>
              </div>

              <div class="form-group" *ngIf="loginStep === 'password'">
                <button type="submit"
                        class="btn btn-primary btn-block mt-3"
                        [disabled]="loading">
                  {{ loading ? 'Logging in...' : 'Log in' }}
                </button>
              </div>

              <div class="login-links">
                <a href="javascript:void(0)" (click)="showForgotPassword()">
                  Forgot password?
                </a>

                <span>|</span>

                <a href="javascript:void(0)" (click)="showSignUp()">
                  Sign up
                </a>
              </div>

            </form>

            <!-- FORGOT PASSWORD FORM -->
            <form *ngIf="loginStep === 'forgotPassword'"
                  [formGroup]="forgotPasswordForm"
                  (ngSubmit)="submitForgotPassword()">

              <div class="fs-12 fw-600 text-warning mb-3">
                Enter your email address and we'll send you a link to reset your password.
              </div>

              <div class="form-group">
                <input class="form-control"
                       type="email"
                       placeholder="Email"
                       formControlName="email"
                       autocomplete="email"
                       [ngClass]="{ 'is-invalid': forgotSubmitted && forgotPasswordForm.controls.email.errors }" />

                <div *ngIf="forgotSubmitted && forgotPasswordForm.controls.email.errors"
                     class="invalid-feedback">
                  <div *ngIf="forgotPasswordForm.controls.email.errors.required">
                    Email is required
                  </div>
                  <div *ngIf="forgotPasswordForm.controls.email.errors.email">
                    Email is not valid
                  </div>
                </div>
              </div>

              <button type="submit"
                      class="btn btn-primary btn-block mt-3"
                      [disabled]="loading">
                {{ loading ? 'Sending...' : 'Send' }}
              </button>

              <button type="button"
                      class="btn btn-light btn-block mt-2"
                      (click)="backToEmailStep()">
                <i class="fas fa-arrow-left mr-1"></i>
                Back to login
              </button>

            </form>



            <!-- SIGN UP FORM -->
            <form *ngIf="loginStep === 'signUp'"
                  [formGroup]="signUpForm"
                  (ngSubmit)="submitSignUp()">

              <div class="fs-12 fw-600 text-warning mb-3">
                Please complete the form below. IOSC support team will review your information and contact you after your account is created.
              </div>

              <div class="form-group">
                <input class="form-control"
                       type="text"
                       placeholder="Name"
                       formControlName="name"
                       autocomplete="given-name"
                       [ngClass]="{ 'is-invalid': signUpSubmitted && signUpForm.controls.name.errors }" />

                <div *ngIf="signUpSubmitted && signUpForm.controls.name.errors" class="invalid-feedback">
                  Name is required
                </div>
              </div>

              <div class="form-group">
                <input class="form-control"
                       type="text"
                       placeholder="Surname"
                       formControlName="surname"
                       autocomplete="family-name"
                       [ngClass]="{ 'is-invalid': signUpSubmitted && signUpForm.controls.surname.errors }" />

                <div *ngIf="signUpSubmitted && signUpForm.controls.surname.errors" class="invalid-feedback">
                  Surname is required
                </div>
              </div>

              <div class="form-group">
                <input class="form-control"
                       type="email"
                       placeholder="Email"
                       formControlName="email"
                       autocomplete="email"
                       [ngClass]="{ 'is-invalid': signUpSubmitted && signUpForm.controls.email.errors }" />

                <div *ngIf="signUpSubmitted && signUpForm.controls.email.errors" class="invalid-feedback">
                  <div *ngIf="signUpForm.controls.email.errors.required">Email is required</div>
                  <div *ngIf="signUpForm.controls.email.errors.email">Email is not valid</div>
                </div>
              </div>

              <div class="form-group">
                <select class="form-control"
                        formControlName="segmentId"
                        (change)="signUpSegmentChange(signUpForm.value.segmentId)"
                        [ngClass]="{ 'is-invalid': signUpSubmitted && signUpForm.value.segmentId == 0 }">
                  <option [ngValue]="0">Segment Level 1</option>
                  <option [ngValue]="s.id" *ngFor="let s of segmentObj">{{ s.name }}</option>
                </select>

                <div *ngIf="signUpSubmitted && signUpForm.value.segmentId == 0" class="invalid-feedback d-block">
                  Segment Level 1 is required
                </div>
              </div>

              <div class="form-group">
                <select class="form-control"
                        formControlName="subSegmentId"
                        (change)="signUpSubSegmentChange(signUpForm.value.subSegmentId)"
                        [ngClass]="{ 'is-invalid': signUpSubmitted && signUpForm.value.subSegmentId == 0 }">
                  <option [ngValue]="0">Segment Level 2</option>
                  <option [ngValue]="ss.id" *ngFor="let ss of subSegmentObj">{{ ss.name }}</option>
                </select>

                <div *ngIf="signUpSubmitted && signUpForm.value.subSegmentId == 0" class="invalid-feedback d-block">
                  Segment Level 2 is required
                </div>
              </div>

              <div class="form-group">
                <select class="form-control"
                        formControlName="ssubSegmentId"
                        [ngClass]="{ 'is-invalid': signUpSubmitted && signUpForm.value.ssubSegmentId == 0 }">
                  <option [ngValue]="0">Segment Level 3</option>
                  <option [ngValue]="sss.id" *ngFor="let sss of ssubSegmentObj">{{ sss.name }}</option>
                </select>

                <div *ngIf="signUpSubmitted && signUpForm.value.ssubSegmentId == 0" class="invalid-feedback d-block">
                  Segment Level 3 is required
                </div>
              </div>

              <button type="submit"
                      class="btn btn-primary btn-block mt-3"
                      [disabled]="loading">
                {{ loading ? 'Sending...' : 'Submit Request' }}
              </button>

              <button type="button"
                      class="btn btn-light btn-block mt-2"
                      (click)="backToEmailStep()">
                <i class="fas fa-arrow-left mr-1"></i>
                Back to login
              </button>

            </form>



            <!-- FORCE NEW PASSWORD FORM -->
            <form *ngIf="loginStep === 'newPassword'"
                  [formGroup]="userPasswordChangeForceForm"
                  (ngSubmit)="onSubmitForce()">

              <div class="fs-12 fw-600 text-warning mb-3">
                For security reasons, you must update your password before continuing.
              </div>

              <div class="validation m-0">
                {{ errorPassword }}
              </div>

              <div class="form-group">
                <label>
                  New Password <span class="text-danger">*</span>
                </label>
                <input type="password"
                       autocomplete="new-password"
                       class="form-control"
                       formControlName="newPassword"
                       tabindex="3"
                       autofocus
                       (keyup)="onPasswordForceKeyup()" />
              </div>

              <div class="form-group">
                <label>
                  Confirm Password <span class="text-danger">*</span>
                </label>
                <input type="password"
                       autocomplete="new-password"
                       class="form-control"
                       formControlName="confirmPassword"
                       tabindex="4"
                       (keyup)="onPasswordForceKeyup()" />
              </div>

              <div class="password-validaitons font-size12px mt-2-3">

                <div class="mt-1">
                  <span class="mr-1"
                        [ngClass]="(userPasswordChangeForceForm.value.newPassword?.length >= 8) ? 'text-success' : 'text-muted'">
                    <i class="fas fa-check-circle"></i>
                  </span>
                  Minimum password length is 8
                </div>

                <div class="mt-1">
                  <span class="mr-1"
                        [ngClass]="hasForcePasswordNumber() ? 'text-success' : 'text-muted'">
                    <i class="fas fa-check-circle"></i>
                  </span>
                  At least 1 number
                </div>

                <div class="mt-1">
                  <span class="mr-1"
                        [ngClass]="hasForcePasswordSymbol() ? 'text-success' : 'text-muted'">
                    <i class="fas fa-check-circle"></i>
                  </span>
                  At least 1 symbol
                </div>

                <div class="mt-1">
                  <span class="mr-1"
                        [ngClass]="hasForcePasswordUppercase() ? 'text-success' : 'text-muted'">
                    <i class="fas fa-check-circle"></i>
                  </span>
                  At least 1 uppercase letter
                </div>

                <div class="mt-1">
                  <span class="mr-1"
                        [ngClass]="(userPasswordChangeForceForm.value.newPassword &&
                              userPasswordChangeForceForm.value.confirmPassword &&
                              userPasswordChangeForceForm.value.newPassword == userPasswordChangeForceForm.value.confirmPassword) ? 'text-success' : 'text-muted'">
                    <i class="fas fa-check-circle"></i>
                  </span>
                  Password matches Confirm Password
                </div>

              </div>

              <div class="d-flex justify-content-between align-items-center mt-3">
                <button type="button"
                        class="btn btn-light btn-sm"
                        (click)="backToEmailStep()">
                  <i class="fas fa-arrow-left mr-1"></i>
                  Back
                </button>

                <button type="submit"
                        class="btn btn-primary btn-sm"
                        [disabled]="spinner">
                  <div class="g_spinner" *ngIf="spinner"></div>
                  {{ spinner ? 'Saving...' : 'Save Password' }}
                </button>
              </div>

            </form>

          </div>
        </div>

        <div class="login-help-text">
          If you experience any issues, please contact us at
          <a href="mailto:ithelp@iosc.az">ithelp@iosc.az</a>
        </div>

        <div *ngIf="loginForm.errors?.invalidLogin && accountNotFound" class="alert alert-danger mt-3 mb-0">
          We could not find an account with this email. Please
          <a href="javascript:void(0)" class="alert-link" (click)="showSignUp()">Sign up</a>
          to request access.
        </div>

        <div *ngIf="loginForm.errors?.invalidLogin && !accountNotFound" class="alert alert-danger mt-3 mb-0">
          {{ errorMessage }}
        </div>

      </div>
    </div>
  </div>
</main>
